import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import utils, { constants } from '@utils';
import { ActionGrid, ActionGridAction } from '@components';
import { Link } from 'react-router-dom';

class Counts extends Component {
	constructor(props) {
		super(props);

		// remove the submission count
		const invoiceStatuses = [...constants.VIEW_INVOICE_STATUS_MAP];
		invoiceStatuses.shift();

		this.invoiceStatuses = invoiceStatuses;
	}

	shouldComponentUpdate({
		viewType,
		activePage,
		loadingCounts,
		counts,
	}) {
		const lastProps = this.props;

		return (
			!isEqual(viewType, lastProps.viewType)
			|| !isEqual(activePage, lastProps.activePage)
			|| !isEqual(loadingCounts, lastProps.loadingCounts)
			|| !isEqual(counts, lastProps.counts)
		);
	}

	getUrl = (viewType) => {
		const {
			activePage,
			search,
		} = this.props;

		return `/payments/${activePage}/${viewType}${search}`;
	}

	getCount = (item) => {
		const { counts } = this.props;

		switch (item.viewType) {
			case 'paid':
				return '';
			case 'dispute':
				return counts[item.countKey];
			default:
				return utils.currencyFormatter(counts[item.countKey]);
		}
	}

	render() {
		const {
			viewType,
			loadingCounts,
		} = this.props;

		return (
			<ActionGrid className="margin-top-40 client-portal-action-grid" id="paymentCounts">
				<For
					index="index"
					each="item"
					of={this.invoiceStatuses}
				>
					<ActionGridAction
						key={`payments_actionGrid_action_${index}`}
						url={this.getUrl(item.viewType)}
						active={item.viewType === viewType}
						disabled={loadingCounts}
						displayName={item.displayName}
						description={item.description}
						count={this.getCount(item)}
						loading={loadingCounts}
						linkComponent={Link}
					/>
				</For>
			</ActionGrid>
		);
	}
}

const mapStateToProps = ({
	router : {
		location: { pathname, search },
		match : {
			params : {
				viewType,
			},
		},
	},
	app : { user : { IsRKPay } },
	payments : {
		counts,
		loading,
	},
}) => ({
	IsRKPay,
	viewType,
	search,
	loading,
	counts,
	activePage : pathname.split('/')[2],
});
Counts.propTypes = {
	activePage    : PropTypes.string,
	counts        : PropTypes.object,
	loadingCounts : PropTypes.bool,
	search        : PropTypes.string,
	viewType      : PropTypes.string,
};

Counts.defaultProps = {
	activePage    : '',
	counts        : {},
	loadingCounts : false,
	search        : '',
	viewType      : '',
};

export default connect(mapStateToProps, null)(Counts);
